import $ from "jquery";
import {checkSymbols, INSTANT_LINK} from "./helpers";
import {sendEvent} from "./analytics";
import {confirmAuthCode, needOperationConfirmAuthCode} from "./authConfirm";
import {openRefillModal} from "./refillAdditional";
import {getCurrentUsdBalanceAmount, getRequestLoanAmount, getAvailableLoanAmount} from "./output";
import {getNotifications} from "./notifications";

export let rates = [];
export let fees = [];
let sendCreditRequest = false,
    showRefillModal = false;
// @TODO requisites -> prop слово то, не написать с первого раза без ошибок)

const CURR_PROP_SELECTOR = '.requisites-block:not(.d-none) .loan-requisite-value';
const CURR_PROPTYPE_SELECTOR = '.requisites-block:not(.d-none) option:selected';
const REQUISITE_ERR_BOX = '.requisites-block:not(.d-none) .requisite-value-error';

const CALCULATE_TYPE_USD = 'usd',
    CALCULATE_TYPE_LOAN_CURRENCY = 'currency',
    CALCULATE_TYPE_PLEDGE = 'pledge';

const LOAN_PERCENT = 1.2,
    // DATE_INTEREST_RATE = 0.033,
    DATE_INTEREST_RATE = 12 / 365 / 100,
    BANK_CARD_PLACEHOLDER = '0000-0000-0000-0000',
    YANDEX_MONEY_PLACEHOLDER = '000000000000000',
    FIAT_LOAN_PERCENT = 0.02,
    FIAT_CURRENCY = ['UAH', 'RUB'],
    CURRENCY_RECALC_RATE = ['USDT'],
    DECLINE_PERCENT = 0.01;

const ERROR_INPUT_DATA = 'error-input-group',
    INFO_BACKGR = 'info-background',
    INFO_BACKGR_SELECT = 'info-background-select',
    NON_VISIBLE = 'd-none',
    ERROR_COLOR = 'error-color',
    MAX_AMOUNT_LOAN_VALUE = $('#max-amount-loan-error'),
    MIN_AMOUNT_LOAN_VALUE = $('#min-amount-loan-error'),
    SELECTED_CURRENCY = $('#loan-currency'),
    NETWORK_FEE_BLOCK = $('#network-fee-block');

let paymentMethod,
    paymentRequisite,
    calculateType = 'usd';

const METHOD_TYPE_CHECK_REQUISITE = 'check_requisite',
    METHOD_TYPE_LOAN_REQUEST = 'loan_request';

const BTC_CURRENCY = 'BTC',
    LOAN_ADDR = 'loan-addr',
    LOAN_BALANCE = 'loan-balance';

let loanBalanceRequest = false,
    confirmRequestModalVisible = false,
    changeCustomDetailConfirm = false

export const MAX_AMOUNT_VALUE = 10000000;

const getLoan = () => {
    showRefillModal = false;
    const loanBalance = checkLoanBalance();
    sendEvent('loanButton');
    setLoanRequestData(calculateType);
    sendCreditRequest = checkLoanData(loanBalance);
    if (loanBalance === false) {
        checkRequisites();
    }

    if (showRefillModal === true) {
        openRefillModal()
    }

    if (sendCreditRequest === true) {
        if (loanBalance === false) {
            checkRequisiteQuery()
        } else {
            createLoanRequest(true);
        }
    }
}

const getLoanCurrency = () => {
    return SELECTED_CURRENCY.text()
}

const checkLoanBalance = () => {
    const currency = getLoanCurrency();
    const type = $("input[name=loan-type]:checked").val();
    if (currency === BTC_CURRENCY && type === LOAN_BALANCE) {
        return true;
    }
    return false;
}

const changeUsdAmount = () => {
    checkSymbols('amount-loan');
    $('#amount-pledge').val('');
    $('#loan-amount-currency').val('');
    calculateType = CALCULATE_TYPE_USD;
    checkAmountMaxValue();
    setLoanRequestData(CALCULATE_TYPE_USD);
    checkLoanData();
}

const changeCurrencyAmount = () => {
    checkSymbols('loan-amount-currency');
    $('#amount-loan').val('');
    $('#amount-pledge').val('');
    calculateType = CALCULATE_TYPE_LOAN_CURRENCY;
    setLoanRequestData(CALCULATE_TYPE_LOAN_CURRENCY);
    checkLoanData();
}

const changePledgeAmount = () => {
    checkSymbols('amount-pledge');
    $('#loan-amount-currency').val('');
    $('#amount-loan').val('');
    calculateType = CALCULATE_TYPE_PLEDGE;
    setLoanRequestData(CALCULATE_TYPE_PLEDGE);
    checkLoanData();
}

function roundAmount(currency_code, amount) {
    // fiat -> 2  crypto -> 8
    let cryptoCC = ['BTC', 'ETH', 'XRP', 'LTC'];
    if (cryptoCC.includes(currency_code)) {
        return parseFloat(amount).toFixed(8);
    }
    return parseFloat(amount).toFixed(2);

}

function setCurrency(currencyCode = '') {
    let currency = 'USDT'
    if (currencyCode) {
        currency = currencyCode
    }
    SELECTED_CURRENCY.text(currency)
    let src = 'images/icons/' + currency.toLowerCase() + '.png'
    document.getElementById('loan-currency-icon').setAttribute('src', src);
}

//calculate loan form values
const setLoanRequestData = (calculateType = CALCULATE_TYPE_USD) => {
    $('#rate-update').text(rates['BTC']['dateUpdated']);
    loanRequisites();
    const btcRate = rates['BTC']['rate'];

    const amountLoan = $('#amount-loan'),
        amountCurrencySelect = $('#loan-amount-currency'),
        amountPledge = $('#amount-pledge'),
        pledgeHint = $('#pledge-hint'),
        amountLoanHint = $('#amount-loan-hint'),
        loanCurrency = getLoanCurrency();

    let amountLoanValue = amountLoan.val(),
        pledgeValue,
        pledgeHintValue,
        currencyAmountValue;

    if (calculateType === CALCULATE_TYPE_USD || calculateType === CALCULATE_TYPE_PLEDGE) {
        if (calculateType === CALCULATE_TYPE_USD) {
            pledgeValue = (amountLoanValue * LOAN_PERCENT * btcRate).toFixed(8);
        }
        if (calculateType === CALCULATE_TYPE_PLEDGE) {
            pledgeValue = amountPledge.val();
            amountLoanValue = Math.round(pledgeValue / btcRate / LOAN_PERCENT * 100) / 100;
        }
        currencyAmountValue = amountLoanValue * calcCurrencyRate(loanCurrency);
        currencyAmountValue = roundAmount(loanCurrency, currencyAmountValue);
    }
    if (calculateType === CALCULATE_TYPE_LOAN_CURRENCY) {
        currencyAmountValue = amountCurrencySelect.val();
        amountLoanValue = Math.round(currencyAmountValue / calcCurrencyRate(loanCurrency) * 100) / 100;
        pledgeValue = (amountLoanValue * LOAN_PERCENT * btcRate).toFixed(8);
    }

    pledgeHintValue = Math.round(amountLoanValue * LOAN_PERCENT * 100) / 100;
    amountLoan.val(amountLoanValue)
    const dailyPercent = calculateLoanDailyPercent(amountLoanValue);
    amountCurrencySelect.val(currencyAmountValue);
    amountPledge.val(pledgeValue);
    amountLoanHint.text(amountLoanValue);
    pledgeHint.text(pledgeHintValue);
    $("#currency-get").text(loanCurrency.toUpperCase());
    $('#loan-daily-percent').text(dailyPercent);

    if (confirmRequestModalVisible) {
        setLoanRequestForConfirm(changeCustomDetailConfirm);
    }
}

const calcCurrencyRate = (loanCurrency) => {
    let rate = rates[loanCurrency]['rate']
    if (FIAT_CURRENCY.includes(loanCurrency)) {
        rate = rate - (rate * FIAT_LOAN_PERCENT);
    }
    if (CURRENCY_RECALC_RATE.includes(loanCurrency)) {
        rate = rate - (rate * DECLINE_PERCENT);
    }

    return rate;
}

const calculateLoanDailyPercent = (amount) => {
    return Math.round(amount * DATE_INTEREST_RATE * 100) / 100;
}

const calculateAccruedInterestAmount = (amount) => {
    const dailyLoanAccrual = Math.round(amount * DATE_INTEREST_RATE * 100) / 100;
    return Math.round(dailyLoanAccrual * 14 * 100) / 100;
}

const loanRequisites = () => {
    const loanCurrency = getLoanCurrency();
    $('.requisites-block').addClass(NON_VISIBLE);
    $('#requisites-' + loanCurrency).removeClass(NON_VISIBLE);
    paymentMethod = $(CURR_PROPTYPE_SELECTOR).value;
    paymentRequisite = $(CURR_PROP_SELECTOR).val();
    placeholderValue();
}

const placeholderValue = () => {
    const visiblePaymentMethod = $(CURR_PROPTYPE_SELECTOR).text().trim()
    if (visiblePaymentMethod == 'Банковская карта' || visiblePaymentMethod == 'Bank card') {
        $(CURR_PROP_SELECTOR).attr('placeholder', BANK_CARD_PLACEHOLDER)
    } else if (visiblePaymentMethod == 'Яндекс.Деньги' || visiblePaymentMethod == 'Yandex.Money') {
        $(CURR_PROP_SELECTOR).attr('placeholder', YANDEX_MONEY_PLACEHOLDER)
    } else {
        $(CURR_PROP_SELECTOR).attr('placeholder', '')
    }
}

// get loan data for request
const getLoanRequestData = () => {
    let loan = [];
    const loanAmount = getRequestLoanAmount();
    const loanPledge = $('#amount-pledge').val();
    const loanCurrency = getLoanCurrency();
    const loanAmountCurrency = $('#loan-amount-currency').val();
    const loanAmountPledge = Math.round(loanAmount * 1.2);
    if (!paymentMethod) {
        paymentMethod = $(CURR_PROPTYPE_SELECTOR).val();
    }

    loan['loanAmount'] = loanAmount;
    loan['loanPledge'] = loanPledge;
    loan['loanCurrency'] = loanCurrency;
    loan['loanAmountCurrency'] = loanAmountCurrency;
    loan['loanAmountPledge'] = loanAmountPledge;
    loan['paymentMethod'] = paymentMethod;
    loan['paymentRequisite'] = paymentRequisite;

    return loan;
}

const createLoanRequest = (changeCustomDetail = false) => {
    confirmRequestModalVisible = true
    changeCustomDetailConfirm = changeCustomDetail
    setLoanRequestForConfirm(changeCustomDetailConfirm)
    $('#requestInstantLoan').modal('show');
}

const checkRequisiteQuery = () => {
    const loan = getLoanRequestData()
    const data = {
        'loan_amount': loan.loanAmount,
        'loan_pledge': loan.loanPledge,
        'currency': loan.loanCurrency,
        'payment_method': loan.paymentMethod,
        'payment_requisite': loan.paymentRequisite,
    }
    const url = 'instant/requisite'
    sendLoanQuery(url, data, METHOD_TYPE_CHECK_REQUISITE)
}

const setRequestPaymentLabel = (paymentMethod) => {
    $('.pay-method-label').addClass(NON_VISIBLE)
    let method = $(CURR_PROPTYPE_SELECTOR).text().trim();
    $('.pay-method-label[d-name="' + method + '"]').removeClass(NON_VISIBLE);
}

const requisiteError = () => {
    $(CURR_PROP_SELECTOR).addClass(ERROR_INPUT_DATA)
}

const loanCurrencyError = () => {
    const loanCurrencyGroup = $('#loan-currency-group');
    loanCurrencyGroup.addClass(ERROR_INPUT_DATA);
}

const loanAmountError = () => {
    const amountLoanGroup = $('#amount-loan-group');
    amountLoanGroup.addClass(ERROR_INPUT_DATA);
}

const confirmLoanRequest = () => {
    const needConfirmed = needOperationConfirmAuthCode();
    if (needConfirmed == 1) {
        confirmAuthCode('loanRequest');
    } else {
        sendLoanRequestQuery();
    }
}

const sendLoanQuery = (url, data, type, loanBalance = false) => {
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        success: function (result) {
            if (result) {
                if (!result.error) {
                    if (type === METHOD_TYPE_CHECK_REQUISITE) {
                        createLoanRequest()
                    }
                    if (type === METHOD_TYPE_LOAN_REQUEST && !loanBalance) {
                        const loanCurrency = result.loanCurrency,
                            loanAmountCurrency = result.loanAmountCurrency
                        showInstantLoanSuccess(loanCurrency, loanAmountCurrency)
                    }
                    if (loanBalance) {
                        getNotifications(true)
                    }
                } else {
                    if (result.field === 's_prop') {
                        showLoanBalanceConfirmModal();
                    } else {
                        setLoanRequestError(result.field, result.msg);
                    }
                }
            }
        }
    });
}

export const sendLoanRequestQuery = () => {
    const checkLoanType = checkLoanBalance()
    const loanBalance = checkLoanType ? checkLoanType : loanBalanceRequest;
    $('#requestInstantLoan').modal('hide');
    confirmRequestModalVisible = false
    changeCustomDetailConfirm = false
    const loanData = getLoanRequestData()
    const loanRequestUrl = '/instant'
    const data = {
        'payment_method': loanData.paymentMethod,
        'loan_amount': loanData.loanAmount,
        'loan_pledge': loanData.loanPledge,
        'currency': loanData.loanCurrency,
        'loan_currency_value': loanData.loanAmountCurrency,
        'requisite': loanData.paymentRequisite,
        'loan_balance': loanBalance,
        'calculate_type': calculateType,
    };

    sendLoanQuery(loanRequestUrl, data, METHOD_TYPE_LOAN_REQUEST, loanBalance)
}

const setLoanRequestError = (fieldName, errorMessage) => {
    if (fieldName === 'requisite') {
        const requisiteBox = $('#requisite-error');
        requisiteBox.removeClass(NON_VISIBLE);
        requisiteBox.text(errorMessage);
        requisiteError();
    } else if (fieldName === 'payment_method') {
        const paymentMethodBox = $('#payment-method-error');
        paymentMethodBox.removeClass(NON_VISIBLE);
        paymentMethodBox.text(errorMessage);
        requisiteError();
    } else if (fieldName === 'currency') {
        const currencyBox = $('#currency-error');
        currencyBox.removeClass(NON_VISIBLE);
        currencyBox.text(errorMessage);
        loanCurrencyError();
    } else if (fieldName === 'loan_amount') {
        const amountLoanError = $('#amount-error');
        amountLoanError.removeClass(NON_VISIBLE);
        amountLoanError.text(errorMessage);
        loanAmountError();
    }
}

const showInstantLoanSuccess = (loanCurrency, loanAmountCurrency) => {
    $('#request-loan-amount').text(loanAmountCurrency);
    $('#request-loan-currency').text(loanCurrency);
    $('#requestInstantLoanSuccess').modal('show');
}

//remove old error from requisites field
const clearFieldsError = () => {
    const amountLoanGroup = $('#amount-loan-group');
    if (amountLoanGroup.hasClass(ERROR_INPUT_DATA)) {
        amountLoanGroup.removeClass(ERROR_INPUT_DATA);
    }
    if (!MIN_AMOUNT_LOAN_VALUE.hasClass(NON_VISIBLE) || !MAX_AMOUNT_LOAN_VALUE.hasClass(NON_VISIBLE)) {
        MIN_AMOUNT_LOAN_VALUE.addClass(NON_VISIBLE);
        MAX_AMOUNT_LOAN_VALUE.addClass(NON_VISIBLE);
    }
    const amountLoanError = $('#amount-error');
    if (!amountLoanError.hasClass(NON_VISIBLE)) {
        amountLoanError.addClass(NON_VISIBLE);
    }
    clearRequisitesError();
}

const checkAmountMaxValue = () => {
    if ($('#amount-loan').val() > MAX_AMOUNT_VALUE) {
        $('#amount-loan').val(MAX_AMOUNT_VALUE)
    }
}

// check form data for get credit
const checkLoanData = (withoutCheckRequisites = false) => {
    clearFieldsError();
    const amountLoanGroup = $('#amount-loan-group');
    const userBalanceUsdText = getCurrentUsdBalanceAmount();
    const amountLoanValueText = getRequestLoanAmount();
    const userBalanceUsd = parseFloat(userBalanceUsdText);
    const amountLoanValue = amountLoanValueText ? parseFloat(amountLoanValueText) : 0;
    const availableForLoan = getAvailableLoanAmount();
    const availableForLoanValue = availableForLoan ? parseFloat(availableForLoan) : 0;
    paymentMethod = $(CURR_PROPTYPE_SELECTOR).val();
    if (!amountLoanValue || amountLoanValue < 100 || (amountLoanValue > userBalanceUsd)
        || !paymentMethod || (!withoutCheckRequisites && !paymentRequisite)
        || amountLoanValue > availableForLoanValue) {
        if (!amountLoanValue || amountLoanValue < 100 || (amountLoanValue > userBalanceUsd && userBalanceUsd > 0)
            || amountLoanValue > availableForLoanValue) {
            if (amountLoanValue < 100 || !amountLoanValue) {
                MIN_AMOUNT_LOAN_VALUE.removeClass(NON_VISIBLE);
            }

            if (userBalanceUsd > 0 && amountLoanValue > availableForLoan) {
                MAX_AMOUNT_LOAN_VALUE.removeClass(NON_VISIBLE);
                amountLoanGroup.addClass(ERROR_INPUT_DATA);
            }

            if (amountLoanValue >= 100 && amountLoanValue > availableForLoanValue) {
                showRefillModal = true;
            }

            sendCreditRequest = false;
        }

        return false;
    }

    return true;
}

function getRate() {
    $.ajax({
        type: 'POST',
        url: '/rates',
        data: {},
        success: function (result) {
            if (result) {
                if (!result.error) {
                    rates = result;
                    setLoanRequestData(calculateType);
                } else {
                    return false;
                }
            }
        }
    });

    return rates
}

const changeInputData = () => {
    clearFieldsError();
    setLoanRequestData();
    checkLoanData();
}

const changeSelectedCurrency = (currencyCode) => {
    setCurrency(currencyCode)
    setLoanRequestData();
    checkLoanData();
}

const checkRequisites = () => {
    clearRequisitesError();
    const requisiteVal = $(CURR_PROP_SELECTOR).val()
    const userBalanceUsdText = getCurrentUsdBalanceAmount();
    const amountLoanValueText = getRequestLoanAmount();
    const availableForLoanText = getAvailableLoanAmount();
    const userBalanceUsd = userBalanceUsdText ? parseFloat(userBalanceUsdText) : 0;
    const amountLoanValue = amountLoanValueText ? parseFloat(amountLoanValueText) : 0;
    const availableForLoan = availableForLoanText ? parseFloat(availableForLoanText) : 0;
    if (!requisiteVal && userBalanceUsd > 0 && amountLoanValue < availableForLoan) {
        requisiteError();
        sendCreditRequest = false;
        $(REQUISITE_ERR_BOX).removeClass(NON_VISIBLE)
    }
}

const clearRequisitesError = () => {
    $('.loan-requisite-value').removeClass(ERROR_INPUT_DATA);
    $(REQUISITE_ERR_BOX).addClass(NON_VISIBLE)
    $('#requisite-error').addClass(NON_VISIBLE);
    $('#payment-method-error').addClass(NON_VISIBLE);
    $('#currency-error').addClass(NON_VISIBLE);
}

const changePaymentMethod = () => {
    placeholderValue();
    paymentMethod = $(CURR_PROPTYPE_SELECTOR).value;
}

const hideRequestInstantLoanSuccess = () => {
    $('#requestInstantLoanSuccess').on('hidden.bs.modal', function (e) {
        window.location.reload();
    })
}

const loanFieldsHover = () => {
    $('#amount-loan').focusin(function () {
        $('#amount-loan-prepend-text').addClass(INFO_BACKGR);
    });
    $('#amount-loan').focusout(function () {
        $('#amount-loan-prepend-text').removeClass(INFO_BACKGR);
    });
    $('#loan-amount-currency').focusin(function () {
        $('#currency-dropdown').addClass(INFO_BACKGR);
    });
    $('#loan-amount-currency').focusout(function () {
        $('#currency-dropdown').removeClass(INFO_BACKGR);
    });
    $('#amount-pledge').focusin(function () {
        $('#amount-pledge-prepend-text').addClass(INFO_BACKGR);
    });
    $('#amount-pledge').focusout(function () {
        $('#amount-pledge-prepend-text').removeClass(INFO_BACKGR);
    });
    $('.loan-requisite-value:not(.d-none)').focusin(function () {
        $('#payment-method:not(.d-none)').addClass(INFO_BACKGR_SELECT);
    });
    $('.loan-requisite-value:not(.d-none)').focusout(function () {
        $('#payment-method:not(.d-none)').removeClass(INFO_BACKGR_SELECT);
    });
}

const confirmLoanBalance = () => {
    loanBalanceRequest = true;
    $('#confirmLoanBalance').modal('hide');
    createLoanRequest(true);
}

const loanAddr = () => {
    $('#requisite-btc-hint').removeClass(NON_VISIBLE)
    $('#loan-addr-text').removeClass(NON_VISIBLE)
    $('#loan-balance-text').addClass(NON_VISIBLE)
    $('#requisite-btc-value').removeClass(NON_VISIBLE)
}

const loanBalance = () => {
    clearRequisitesError();
    $('#requisite-btc-hint').addClass(NON_VISIBLE)
    $('#loan-balance-text').removeClass(NON_VISIBLE)
    $('#loan-addr-text').addClass(NON_VISIBLE)
    $('#requisite-btc-value').addClass(NON_VISIBLE)
}

const showLoanBalanceConfirmModal = () => {
    $('#confirmLoanBalance').modal('show');
}

function setLoanRequestForConfirm(changeCustomDetail = false) {
    const loanRequestData = getLoanRequestData();
    setRequestPaymentLabel(loanRequestData['paymentMethod']);
    setFeeData(loanRequestData['loanCurrency'], loanRequestData['paymentMethod'], loanRequestData['loanAmount'])
    const loanAmount = loanRequestData['loanAmount'];
    const dailyPercent = calculateLoanDailyPercent(loanAmount);
    const accruedInterestAmount = calculateAccruedInterestAmount(loanAmount);
    $('#request-amount-loan-value').text(loanAmount);
    $('#request-amount-pledge-value').text(loanRequestData['loanPledge']);
    $('#request-loan-currency-value').text(loanRequestData['loanAmountCurrency'] + ' ' + loanRequestData['loanCurrency'].toUpperCase());
    $('#request-pledge-value').text(loanRequestData['loanAmountPledge']);
    if (changeCustomDetail === false) {
        $('#req-detail-block').removeClass(NON_VISIBLE)
        $('#request-payment-requisite').text(loanRequestData['paymentRequisite']);
    } else {
        $('#loan-balance-detail-block').removeClass(NON_VISIBLE)
    }
    $('#request-daily-accrual-value').text(dailyPercent);
    $('#accrued-interest-amount').text(accruedInterestAmount);
}

function getAvgFees() {
    $.ajax({
        type: 'POST',
        url: '/fees',
        data: {},
        success: function (result) {
            if (result) {
                if (!result.error) {
                    fees = result;
                } else {
                    return false;
                }
            }
        }
    });
}

function setFeeData(currency, paymentMethodId, loanAmount) {
    const I_FEE_AMOUNT = $('#i-fee-amount')
    const I_FEE_CURRENCY = $('#i-fee-currency')
    const I_FEE_AMOUNT_USD = $('#i-fee-amount-usd')
    const I_FEE_USD = $('#i-fee-usd')
    const I_FEE_BTK = $('#i-fee-bkt')
    const loanBalance = checkLoanBalance();
    if (FIAT_CURRENCY.includes(currency) || loanBalance) {
       NETWORK_FEE_BLOCK.addClass(NON_VISIBLE)
    } else {
        NETWORK_FEE_BLOCK.removeClass(NON_VISIBLE)
        const ident = currency + '_' + paymentMethodId
        const fee = fees[ident]
        const feeUsd = parseFloat(fee['fee_usd'])
        const totalUsd = Math.round((feeUsd + parseFloat(loanAmount)) * 100) / 100;
        const feeCurrency = fee['fee_currency']
        if (feeCurrency === 'ETH') {
            I_FEE_AMOUNT.addClass(ERROR_COLOR);
            I_FEE_CURRENCY.addClass(ERROR_COLOR);
            I_FEE_AMOUNT_USD.addClass(ERROR_COLOR);
            I_FEE_USD.addClass(ERROR_COLOR);
            I_FEE_BTK.addClass(ERROR_COLOR);
        } else {
            if (I_FEE_AMOUNT.hasClass(ERROR_COLOR)) {
                I_FEE_AMOUNT.removeClass(ERROR_COLOR);
            }
            if (I_FEE_CURRENCY.hasClass(ERROR_COLOR)) {
                I_FEE_CURRENCY.removeClass(ERROR_COLOR);
            }
            if (I_FEE_AMOUNT_USD.hasClass(ERROR_COLOR)) {
                I_FEE_AMOUNT_USD.removeClass(ERROR_COLOR);
            }
            if (I_FEE_USD.hasClass(ERROR_COLOR)) {
                I_FEE_USD.removeClass(ERROR_COLOR);
            }
            if (I_FEE_BTK.hasClass(ERROR_COLOR)) {
                I_FEE_BTK.removeClass(ERROR_COLOR);
            }
        }
        I_FEE_AMOUNT.text(fee['fee']);
        I_FEE_CURRENCY.text(feeCurrency);
        I_FEE_AMOUNT_USD.text(feeUsd);
        $('#i-total-amount').text(totalUsd);
    }
}

$(document).ready(() => {
    if (window.location.pathname === INSTANT_LINK) {
        getRate();
        getAvgFees();
        setInterval(function() {
            getRate();
        }, 30 * 1000);
        setInterval(function() {
            getAvgFees();
        }, 60 * 1000);
    }
    hideRequestInstantLoanSuccess();
    loanFieldsHover();
});

window.getLoan = getLoan;
window.changeInputData = changeInputData;
window.changeSelectedCurrency = changeSelectedCurrency;
window.changePaymentMethod = changePaymentMethod;
window.confirmLoanRequest = confirmLoanRequest;
window.changePledgeAmount = changePledgeAmount;
window.changeCurrencyAmount = changeCurrencyAmount;
window.changeUsdAmount = changeUsdAmount;
window.checkRequisites = checkRequisites;
window.clearRequisitesError = clearRequisitesError;
window.confirmLoanBalance = confirmLoanBalance;
window.loanAddr = loanAddr;
window.loanBalance = loanBalance;
